import React from 'react';
import classNames from 'classnames';

import {
	TRACK_DIFFICULTY_BLACK,
	TRACK_DIFFICULTY_BLUE,
	TRACK_DIFFICULTY_RED,
	TRACK_DIFFICULTY_GREEN,
	TRACK_STATE_DIFFICULTY,
	TRACK_STATE_STATUS, TRACK_STATUS_CLOSED, TRACK_STATUS_OPEN
} from "../config/constants";
import { labelColors, liftsColors, liftsColorsStatus, tracksColors } from "../config/styles";

import PopupTrackContent from "../components/popup/PopupTrackContent";
import Label from "../components/UI/Label";

const getTrackColorByDifficulty = difficulty => {
	let color;

	switch (difficulty) {
		case TRACK_DIFFICULTY_BLACK:
			color = tracksColors.black;
			break;
		case TRACK_DIFFICULTY_BLUE:
			color = tracksColors.blue;
			break;
		case TRACK_DIFFICULTY_RED:
			color = tracksColors.red;
			break;
		case TRACK_DIFFICULTY_GREEN:
			color = tracksColors.green;
			break;
		default:
			color = '#000';
	}

	return color
};

const getTrackColorByWorkingState = workingState => {
	let color;
	switch (workingState) {
		case TRACK_STATUS_OPEN:
			color = tracksColors.open;
			break;
		case TRACK_STATUS_CLOSED:
			color = tracksColors.closed;
			break;
		default:
			color = '#000';
	}

	return color;
};

export const getTrackColorByStateAndDifficulty = (state, workingState, difficulty) => {
	let color = '#000000';

	if (state === TRACK_STATE_DIFFICULTY) {
		color = getTrackColorByDifficulty(difficulty);
	}

	if (state === TRACK_STATE_STATUS) {
		color = getTrackColorByWorkingState(workingState);
	}

	return color;
};

export const getLabelColorByStateAndDifficulty = (state, workingState, difficulty) => {
	let colors;

	if (state === TRACK_STATE_DIFFICULTY) {
		switch (difficulty) {
			case TRACK_DIFFICULTY_BLACK:
				colors = labelColors.black;
				break;
			case TRACK_DIFFICULTY_BLUE:
				colors = labelColors.blue;
				break;
			case TRACK_DIFFICULTY_RED:
				colors = labelColors.red;
				break;
			case TRACK_DIFFICULTY_GREEN:
				colors = labelColors.green;
				break;
			default:
				colors = ['#000', '#000'];
				break;
		}
	}

	if (state === TRACK_STATE_STATUS) {
		switch (workingState) {
			case TRACK_STATUS_OPEN:
				colors = labelColors.open;
				break;
			case TRACK_STATUS_CLOSED:
				colors = labelColors.closed;
				break;
		}
	}

	return colors;
};

const mapContainer = document.getElementById('mapRoot');

export const getMapTopOffset = () => {
	const mapRootDim = mapContainer.getBoundingClientRect();
	return mapRootDim.y + window.scrollY;
};

export const getMapCoordsForMove = (labelRef, mapCoords, isMobile) => {
	let { x, y, scale } = mapCoords;
	const labelDim = labelRef.getBoundingClientRect();
	const legendOffset = isMobile ? window.innerWidth : 160;
	let mapX = (x - labelDim.x) + window.innerWidth / scale + (scale > 2 ? (isMobile ? 8 : 10) * scale : 0) + legendOffset / scale;
	let mapY = (y - labelDim.y) + window.innerHeight / scale + (scale > 2 ? (isMobile ? 20 : 10) * scale : 0);

	if (scale <= 1.7)
		mapY /= 1.7;

	if (mapX > 0) mapX = 0;
	if (mapY > 0) mapY = 0;

	scale = Math.round(scale * 100) / 100;

	return { mapX, mapY, scale };
};

export const getInitialParamsForContainer = (isFromApp) => {
	const windowWidth = window.innerWidth;
	const windowHeight = window.innerHeight;
	const windowProportion = windowWidth / windowHeight;

	let initialScale;
	let minScale;
	let maxScale;
	let defaultPositionX;
	let defaultPositionY;

	switch (true) {
		case windowWidth <= 1050 && windowWidth > 770:
			minScale = 3;
			maxScale = 4;
			initialScale = 3;
			defaultPositionX = windowHeight <= 500 ? -650 : -520;
			defaultPositionY = windowHeight <= 500 ? -430 : -(windowHeight);
			break;
		case windowWidth >= 620 && windowWidth < 780:
			minScale = 2.6;
			maxScale = 5;
			initialScale = 2.6;
			defaultPositionX = windowHeight <= 500 ? -450 : -470;
			defaultPositionY = windowHeight <= 500 ? -(windowHeight / 2 + 100) : -(windowHeight / 2 + 300);
			break;
		case windowWidth < 620:
			minScale = 1;
			maxScale = 9;
			initialScale = 5;
			defaultPositionX = -(windowWidth + 100);
			defaultPositionY = -(windowHeight + windowWidth / windowProportion) - (isFromApp ? 0 : 150); //On real devices - 150
			break;
		default:
			minScale = 1;
			maxScale = 3;
			initialScale = 2;
			defaultPositionX = -(windowWidth / 2 - 320);
			defaultPositionY = -(windowHeight / 2);
			break;
	}

	return { initialScale, minScale, maxScale, defaultPositionX, defaultPositionY }
};

export const getPanProps = () => {
	return {
		velocity: false,
		padding: false,
		panPaddingShiftTime: 0,
		paddingSize: 0,
		animationTime: 0
	}
};

export const getServerTrackStatusToClient = serverTrackStatus => {
	return serverTrackStatus === 'waiting' || serverTrackStatus === 'close' || serverTrackStatus === 'closed' ? TRACK_STATUS_CLOSED : TRACK_STATUS_OPEN;
};

export const prepareTracksDataFromServer = tracksData => {
	let newTracksData = {};

	Object.keys(tracksData).map(trackId => {
		const preparedTrack = {
			...tracksData[trackId],
			isShow: true,
			status: getServerTrackStatusToClient(tracksData[trackId].status)
		};

		newTracksData = {
			...newTracksData,
			[trackId]: preparedTrack
		}
	});

	return newTracksData;
};

export const getMarkersVisibility = data => ({
	showFoodMarkers: data.showFoodMarkers,
	showRentMarkers: data.showRentMarkers,
	showMedicalMarkers: data.showMedicalMarkers,
	showSkatingMarkers: data.showSkatingMarkers,
	showSkiMarkers: data.showSkiMarkers
});

export const setMapCoordsData = (prevData, x, y, scale) => {
	return {
		...prevData,
		x,
		y,
		scale
	}
};

export const getPopupTrackInfoParams = trackData => {
	const { info } = trackData;
	return {
		title: info.name,
		status: trackData.status,
		info: {
			topHeight: info.top_height,
			bottomHeight: info.bottom_height,
			length: info.distance,
			notes: info.notes,
			difficulty: trackData.difficulty,
		}
	};

	// const data = {
	//    "status": "open",
	//    "start_date": "2019-12-30",
	//    "stop_date": null,
	//    "difficulty": "red",
	//    "info": {
	//       "distance": "1674",
	//       "bottom_height": "1153",
	//       "top_height": "1371",
	//       "notes": [],
	//       "name": "12A",
	//       "lift": {
	//          "id": 46,
	//          "name": "12"
	//       }
	//    }
	// }
};

export const getWorkingTracksCount = tracksData => {
	let workingCount = 0;

	Object.keys(tracksData).forEach(trackId => {
		if (tracksData[trackId].status === TRACK_STATUS_OPEN)
			workingCount += 1;
	});

	return workingCount;
};

export const getOpenTracksObject = tracksData => {
	const filteredTracks = {};

	Object.keys(tracksData).map(trackId => {
		if (tracksData[trackId].status === TRACK_STATUS_OPEN)
			filteredTracks[trackId] = tracksData[trackId];
	});

	return filteredTracks;
};

export const getClosedTracksObject = tracksData => {
	const filteredTracks = {};

	Object.keys(tracksData).map(trackId => {
		if (tracksData[trackId].status === TRACK_STATUS_CLOSED)
			filteredTracks[trackId] = tracksData[trackId];
	});

	return filteredTracks;
};

export const prepareTracksFromServerWaitingTracksToClient = tracks => {
	const formattedObject = {};
	tracks.forEach(trackObject => {
		Object.keys(trackObject).forEach(trackId => {
			formattedObject[trackId] = trackObject[trackId];
		})
	});

	return formattedObject;
};

export const getLiftColor = (isOpen, state) => liftsColors[isOpen || state === TRACK_STATE_DIFFICULTY ? 'open' : 'closed'];
export const getLiftStatusColors = (state, isOpen) => {
	return state === TRACK_STATE_DIFFICULTY ? getLiftColor(isOpen, state) : liftsColorsStatus[isOpen ? 'open' : 'closed'];
};

export const getLiftClass = (isOpen, isActive, state) => classNames('lift', {
	'lift--closed': !isOpen,
	'lift--active': isActive,
	'lift--animated': state === TRACK_STATE_STATUS && isOpen
});

export const separateLiftsByTypeWithCounts = liftsData => {
	let lifts = { counts: {} };

	Object.keys(liftsData).forEach(liftId => {
		const liftType = liftsData[liftId].info.type;

		if(typeof lifts[liftType] !== 'undefined') {
			lifts[liftType].push(liftsData[liftId]);
		} else {
			lifts[liftType] = [liftsData[liftId]];
			lifts.counts[liftType] = { open: 0, closed: 0, count: 0 }
		}

		const liftCount = lifts.counts[liftType];

		lifts.counts[liftType].count = liftCount.count + 1;

		if (liftsData[liftId].isOpen)
			lifts.counts[liftType].open = liftCount.open + 1;
		else
			lifts.counts[liftType].closed = liftCount.closed + 1;
	});

	return lifts;
};

export const getOpenLifts = liftsData => {
	let openLifts = {};

	Object.keys(liftsData).forEach(liftId => {
		if (liftsData[liftId].isOpen)
			openLifts[liftId] = liftsData[liftId];
	});

	return openLifts;
};

export const getClosedLifts = liftsData => {
	let openLifts = {};

	Object.keys(liftsData).forEach(liftId => {
		if (!liftsData[liftId].isOpen)
			openLifts[liftId] = liftsData[liftId];
	});

	return openLifts;
};

export const sortLiftsArray = liftsArray => {
	return liftsArray.sort(function (a, b) {
		if (parseInt(a.info.name, 10) > parseInt(b.info.name, 10)) return 1;
		if (parseInt(a.info.name, 10) < parseInt(b.info.name, 10)) return -1;
		return 0;
	});
};

export const sortTracksObject = tracksObject => {
	const sortableWithNumbers = [];
	const sortableWithLetters = [];
	const result = {};

	for (let trackId in tracksObject) {
		if (parseInt(tracksObject[trackId].info.name, 10))
			sortableWithNumbers.push([trackId, tracksObject[trackId]]);
		else
			sortableWithLetters.push([trackId, tracksObject[trackId]]);
	}

	function compare(a, b) {
		if (a > b) return 1;
		if (a < b) return -1;

		return 0;
	}

	sortableWithNumbers.sort(function (a, b) {
		const aItem = parseInt(a[1].info.name, 10);
		const bItem = parseInt(b[1].info.name, 10);
		return compare(aItem, bItem);
	});

	sortableWithLetters.sort(function (a, b) {
		const aItem = a[1].info.name;
		const bItem = b[1].info.name;
		return compare(aItem, bItem);
	});

	sortableWithNumbers.forEach(trackArray => result[trackArray[0]] = trackArray[1]);
	sortableWithLetters.forEach(trackArray => result[trackArray[0]] = trackArray[1]);

	return result;
};

export const getPopupContent = (trackId, trackData) => {
	const { info, title, status } = getPopupTrackInfoParams(trackData);
	return <PopupTrackContent
		trackInfo={info}
		title={title}
		trackStatus={status}
	/>;
};

/**
 * @param coords
 * @param color
 * @param onLabelClick
 * @param text
 * @param id
 * @param textCoordsX
 * @param textCoordsY
 * @param size
 * @returns {*}
 */
export const renderLabelHelper = (coords, color, onLabelClick, text, id, textCoordsX, textCoordsY, size) => {
	return <Label
		onClick={(event, ref) => onLabelClick(event, ref, id)}
		coords={coords}
		text={text}
		textCoordsX={textCoordsX}
		textCoordsY={textCoordsY}
		size={size}
		colors={color}
		id={id}
	/>
};
